import React, { useState, useEffect } from 'react';
import Scroller from 'components/Scroller';
import Menu from 'components/Menu';
import NavList from 'components/NavList';
import Icon from 'components/Icon';
import './HeaderNav.scss';

const Index = () => {
	const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
	const [containerElement, setContainerElement] = useState();
	const [scrollingElement, setScrollingElement] = useState();

	const sendTeaserImageUrl = teaserImageUrl => {
		setBackgroundImageUrl(teaserImageUrl);
	};

	const openHeaderNav = () => {
		document.querySelector('.layout__header-nav').classList.remove('layout__header-nav--hidden');
	};

	const closeHeaderNav = () => {
		document.querySelector('.layout__header-nav').classList.add('layout__header-nav--hidden');
	};

	useEffect(() => {
		setContainerElement(document.querySelector('.header-nav__nav-wrapper'));
		setScrollingElement(document.querySelector('.nav__list'));
	});

	return (
		<section className="layout__header-nav" aria-label="Header & navigation">
			<div className="header-nav__toggle-icons-wrapper">
				<Icon classes={['icon--close']} name="x" handleClick={closeHeaderNav} />
				<Icon classes={['icon--open']} name="menu" handleClick={openHeaderNav} />
			</div>
			<header className="header-nav__header-wrapper">
				<div
					className="header-background-image"
					style={{ backgroundImage: `url(${backgroundImageUrl})` }}
				/>
				<Menu />
			</header>
			<div className="header-nav__nav-wrapper">
				{containerElement && (
					<Scroller
						containerElement={containerElement}
						scrollingElement={scrollingElement}
						scrollToTop={true}
						scrollAmount={window.innerHeight / 1.65}
					/>
				)}
				<Menu />
				<nav className="nav">
					<NavList sendTeaserImageUrl={sendTeaserImageUrl} />
				</nav>
			</div>
		</section>
	);
};

export default Index;
